import * as yup from 'yup';
import moment from 'moment';

const CHAR_LIMIT = 200;
const characterLimitError = `The character limit for this field is ${CHAR_LIMIT}`;

/**
 * Yup validation schema for form validation.
 * Non-required fields are received and sent as nulls to the backend, so these fields are nullable.
 */
const contactNoteValidationSchema = (usedInBr: boolean) =>
  yup.object().shape({
    partner: usedInBr
      ? yup.object().nullable()
      : yup.object().shape({
          partnerUId: yup.string().nullable().required('Please provide a partner'),
        }),

    relatedPartners: usedInBr
      ? yup.array().when('source', {
          is: 'MYTRAVEL',
          then: yup.array().nullable(),
          otherwise: yup
            .array()
            .of(
              yup.object().shape({
                partnerUId: yup.string().nullable(),
              }),
            )
            .min(1, 'Please select at least one related partner'),
        })
      : yup.array().nullable(),

    subject: yup.string().max(CHAR_LIMIT, characterLimitError).required('Please provide a subject'),

    contactType: yup.string().nullable().required('Please select a contact type'),

    contactTypeOther: yup
      .string()
      .nullable()
      .when('contactType', {
        is: 'OTHER',
        then: yup.string().nullable().required('Please specify a contact type other'),
      }),

    startDateTime: yup
      .date()
      .nullable()
      .required('Please provide a valid date & time')
      .when('source', {
        is: 'MYTRAVEL',
        then: yup.date().nullable().required('Please provide a valid date & time'),
        otherwise: yup
          .date()
          .nullable()
          .required('Please provide a valid date & time')
          .min(moment().subtract(45, 'days').toDate(), 'A contact note can be backdated up to 45 days'),
      }),

    endDateTime: yup
      .date()
      .nullable()
      .required('Please provide a valid date & time')
      .min(yup.ref('startDateTime'), `The end date needs to be after the start date`),

    qualifiedClientContact: yup.boolean().nullable().required('Please provide the client contact context'),
    crossBorderActivity: yup.string().nullable().required('Please provide the cross border context'),

    locationCountry: yup
      .string()
      .nullable()
      .when('crossBorderActivity', {
        is: 'true',
        then: yup.string().required('Please provide a country for cross border activity'),
      }),

    locationCity: yup.string().nullable(),

    topics: yup.array().of(yup.string()).min(1, 'Please select at least one topic'),

    initiatedBy: yup.string().nullable().required('Please select the initiator'),

    notes: yup.string().nullable().required('Please provide input into the notes field'),

    source: yup.string().nullable(),

    direction: yup
      .string()
      .nullable()
      .when('contactType', {
        is: 'EMAIL',
        then: yup.string().nullable().required('Please provide the contact direction'),
      }),
  });

export default contactNoteValidationSchema;
